import { useEffect, useState, useRef } from "react";
import { MessageSquare, ChevronLeft, ChevronRight, ChevronsUp, ChevronsDown, ChevronUp, ChevronDown, UserX, UserCheck, Info } from 'react-feather';
import { useRemote, handleComplianceRead, handlePeerRead, handleSupervisorRead, showConfirmActionModal, useStorage, handlePeerRejectClick, handleComplianceRejectClick, handleSupervisorRejectClick } from "../../Utils/Utils";
import { PAGES, ROUTE_PATHS } from '../../InternalApiApp'
import { format, parseISO } from "date-fns";
import { useHistory } from "react-router-dom";
import Modal from "./Modal";
import FlexWrapper from "../../layouts/FlexWrapper";
import Divider from "../Divider";
import PDFViewer from "../PDFViewer";
import ReviewVideoPreview from "../ReviewVideoPreview";
import ErrorBoundary from "../ErrorBoundary";
import CommentsSection from "../Comments/CommentsSection";
import IconLink from "../Menus/IconLink";
import ConfirmActionModal from "./ConfirmActionModal";
import Tooltip from "../popups/Tooltip";
import VideoIndicator from "../Labels/VideoIndicator";
import "./DraftNotePreviewModal.scss";


const DraftNotePreviewModal = ({ handleClose, data, doc, currentIndex, allRequests, setRowActivePreview, compliance, autoOpenComments, refreshList, singleDocViewer, noActions, setActiveNotification, historical, step }) => {
	const [page, setPage] = useState(1);
	const [totalPages, setTotalPages] = useState(null);
	const [twoPageView, setTwoPageView] = useState(false);
	const [commentsOpen, setCommentsOpen] = useState(false);
	const [comments, setComments] = useState([])
	const [blankPageMesurements, setBlankPageMesurements] = useState({ width: 0, height: 0 })
	const [confirmActionModal, setConfirmActionModal] = useState(null);
	const [me, setMe] = useState({});
	const [text, setText] = useState('')
	const [showResolveComment, setShowResolveComment] = useState(null);
	const [rejectionSubmitted, setRejectionSubmitted] = useState(false);

	const previewContentRef = useRef()
	const storage = useStorage()
	const history = useHistory()
	const remote = useRemote()

	const perms = me?.perms || [];
	const currentUserHasRejected = me && me.email && data && data.reviewResponderActions && data.reviewResponderActions.find(response => response.status === "Rejected" && response.responderEmail === me.email)
	const currentUserHasApproved = me && me.email && data && data.reviewResponderActions && data.reviewResponderActions.find(response => response.status === "Approved" && response.responderEmail === me.email)
	const rejectionAction = data && data.reviewResponderActions && data.reviewResponderActions.find(response => response.status === "Rejected")
	const unresolvedComments = comments && comments.length > 0 && comments.filter(c => c.status === 'RAISED').length
	const canNotComment = perms && !perms.includes("REVIEW_PEER") && !perms.includes("REVIEW_COMPLIANCE") && !perms.includes("REVIEW_SUPERVISOR")

	useEffect(() => {
		sessionStorage.getItem("3SKYE.draft.modal.2PageView") === "true" ? setTwoPageView(true) : setTwoPageView(false)
		document.addEventListener("keydown", handleKeyDown);
		storage.getOrFetch(`/crm/me`).then((res) => {
			setMe(res)

			if (res.perms) {
				if (res.perms.includes("REVIEW_PEER")) {
					handlePeerRead(data.template, data.ticker, data.requestId, data.workflowStatusId)
				} else if (res.perms.includes("REVIEW_COMPLIANCE")) {
					handleComplianceRead(data.template, data.ticker, data.requestId, data.workflowStatusId)
				} else if (res.perms.includes("REVIEW_SUPERVISOR")) {
					handleSupervisorRead(data.template, data.ticker, data.requestId, data.workflowStatusId)
				}
			}
		})

		return () => {
			document.removeEventListener("keydown", handleKeyDown);
			if (setActiveNotification) setActiveNotification(null)
		};
	}, []);

	useEffect(() => {
		if (confirmActionModal && text && !showResolveComment) {
			let permittedAction = perms.includes("REVIEW_PEER")
				? "rejectPeerReview" : perms.includes("REVIEW_COMPLIANCE")
					? "rejectCompliance" : perms.includes("REVIEW_SUPERVISOR")
						? "rejectSupervisor"
						: null
			permittedAction && showConfirmActionModal(permittedAction, setConfirmActionModal, data?.template, data?.ticker, data?.requestId, refreshList, data.workflowStatusId, text, setText)

			let confirmButton = permittedAction !== null ? {
				variant: "danger",
				label: "Yes, reject draft",
				onClick: () => {
					if (permittedAction === 'rejectPeerReview') {
						handlePeerRejectClick(data?.template, data?.ticker, data?.requestId, refreshList, data?.workflowStatusId, text, setRejectionSubmitted);
					} else if (permittedAction === 'rejectCompliance') {
						handleComplianceRejectClick(data?.template, data?.ticker, data?.requestId, refreshList, data?.workflowStatusId, text, setRejectionSubmitted);
					} else if (permittedAction === 'rejectSupervisor') {
						handleSupervisorRejectClick(data?.template, data?.ticker, data?.requestId, refreshList, data?.workflowStatusId, text, setRejectionSubmitted);
					}
					setConfirmActionModal(null)
				}
			} : null
			setConfirmActionModal({ ...confirmActionModal, text: text, confirmButton })

		} else if (showResolveComment && text) {
			let confirmButton = {
				variant: "positive",
				label: "Yes, resolve",
				onClick: () => {
					const dto = { ...showResolveComment.dto, comment: text }
					remote.post(showResolveComment.path, dto).then((resp) => {
						showResolveComment.callBack && showResolveComment.callBack()
						setText("")
						setShowResolveComment(null)
						refreshList && refreshList(false)
					})
				}
			}
			setShowResolveComment({ ...showResolveComment, text: text, confirmButton })
		}
	}, [text])

	useEffect(() => {
		if (!singleDocViewer) {
			if (currentIndex !== null) history.push(ROUTE_PATHS[PAGES.REQUESTS] + '/' + data.requestId)
			else history.push(ROUTE_PATHS[PAGES.REQUESTS])
		}
	}, [currentIndex])

	useEffect(() => {
		if (autoOpenComments) {
			setCommentsOpen(true)
		}
	}, [autoOpenComments])

	useEffect(() => {
		// fetch comments
		if (!data.ticker) return;
		if (!data.template) return;

		const identifier = btoa(data.ticker);
		const requestId = data?.requestId || null
		const workflowStatusId = data?.workflowStatusId || null
		let url = `/comments/${identifier}/${data.template}${requestId && workflowStatusId ? '?requestId=' + requestId + "&workflowStatusId=" + workflowStatusId : requestId ? '?requestId=' + requestId : workflowStatusId ? '?workflowStatusId=' + workflowStatusId : ""}`
		const params = new URLSearchParams();
		if (data.requestId) params.append("requestId", data.requestId);
		if (data.workflowStatusId) params.append("workflowStatusId", data.workflowStatusId);

		storage.getOrFetch(url).then((val) => {
			let fetchedComments = []

			val.forEach(comment => {
				if (!comment.replyTo) {
					fetchedComments.push(comment)
				} else {
					const parentComment = val.find(c => c.commentId === comment.replyTo)
					if (!parentComment.replies) parentComment.replies = [comment]
					else parentComment.replies.push(comment)
				}
			})
			setComments(fetchedComments)
		})
	}, [])

	const handleSetTwoPageView = (value) => {
		setTwoPageView(value);
		sessionStorage.setItem("3SKYE.draft.modal.2PageView", value);
	};

	const handleKeyDown = (e) => {
		if (e.key === "Escape") {
			handleClose();
		}
	};

	const handleOverlayClick = (e) => {
		// Check if the clicked element or any of its ancestors have the classes 'floating-sidebar' or 'preview-wrapper'
		if (!hasAncestorWithClass(e.target, "floating-sidebar") && !hasAncestorWithClass(e.target, "preview-wrapper") && !hasAncestorWithClass(e.target, "popup-menu")) {
			// Trigger the handleClose function if the clicked element or its ancestors don't have the specified classes
			handleClose();
		}
	};

	// Helper function to check if the element or any of its ancestors have a specific class
	const hasAncestorWithClass = (element, className) => {
		let currentElement = element;
		while (currentElement) {
			if (currentElement.classList.contains(className)) {
				return true;
			}
			currentElement = currentElement.parentElement;
		}
		return false;
	};

	const errorFallback = (
		<div style={{
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			paddingTop: "4rem"
		}}
		>
			<div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
				<p>An error occurred while loading this note. </p>
				<a
					href="mailto:kathryn.warusevitane@craigsip.com?subject=Investor Portal - Trouble Logging In"
					target="_blank"
					className="text-link colour-text-primary"
				>
					Contact Us
				</a>
			</div>
		</div>
	)

	const gotToPreviousNote = () => {
		if (currentIndex === 0) setRowActivePreview(allRequests.length - 1)
		else setRowActivePreview(currentIndex - 1)
	}

	const gotToNextNote = () => {
		if (currentIndex === allRequests.length - 1) {
			setRowActivePreview(0)

		} else {
			setRowActivePreview(currentIndex + 1)
		}
	}

	function calculatePage(page, up, doble, extreme) {
		if (extreme) {
			if (doble) {
				if (up) return totalPages % 2 === 0 ? totalPages - 1 : totalPages
				else return 1
			} else {
				if (up) return totalPages
				else return 1
			}
		} else {
			if (doble) {
				if (up) return totalPages % 2 === 0 && page === totalPages - 1 ? totalPages - 1 : totalPages % 2 !== 0 && page === totalPages ? totalPages : page + 2
				else return page === 1 ? 1 : page - 2
			} else {
				if (up) return page === totalPages ? totalPages : page + 1
				else return page === 1 ? 1 : page - 1
			}
		}
	}

	function handleDoublePage() {
		const correctPage = page % 2 === 0 ? page - 1 : page
		setPage(correctPage)
		handleSetTwoPageView(true)
	}

	function getIsDisabled(button) {
		if (!perms.includes("REVIEW_COMPLIANCE") && !perms.includes("REVIEW_PEER") && !perms.includes("REVIEW_SUPERVISOR")) {
			return true
		} else {
			const hasRejection = doc?.reviewResponderActions && doc.reviewResponderActions.find(a => a.status === 'Rejected')
			if (hasRejection && me.name !== hasRejection.responderName) return true
			else if (button === 'reject' && hasRejection) return true
			else return false
		}
	}


	const isVideo = data?.contentType === 'video';

	// Historical rejection snapshot routing.
	// A cancelled/rejected record (workflow no longer active, never published) must show the artefact
	// captured AT rejection — not re-resolved live, which would show the author's CURRENT draft rather
	// than what was actually rejected. The snapshot reference is delivered directly on the request DTO
	// (data.rejectionSnapshot*) from ReviewStatusDTO — it is anchored to the rejection comment on the
	// backend, so a reused STANDARD_AUTO request row can't make it stale. Active workflows
	// (historical === false) always show live content.
	const safeParseJson = (s) => { try { return s ? JSON.parse(s) : null; } catch { return null; } };
	// A cancelled/finished-but-unpublished record must NEVER fall back to live content — live would show
	// the author's current draft, not what was reviewed. Show the captured snapshot if present, else the
	// "no longer available" placeholder (this also covers backward-compat records rejected before
	// snapshots existed, which have no snapshot reference).
	const isHistoricalUnpublished = !!(historical && !data.isPublished);
	const snapshotCommentId = data?.rejectionSnapshotCommentId || null;
	const showSnapshot = isHistoricalUnpublished && !!snapshotCommentId;
	const snapshotIsVideo = showSnapshot && data.rejectionSnapshotContentType === 'video';
	const snapshotVideoData = snapshotIsVideo ? safeParseJson(data.rejectionSnapshotVideoData) : null;
	// Placeholder when the snapshot's artefact can't be resolved, OR this is a historical unpublished
	// record with no snapshot at all (backward compat / capture failed).
	const snapshotUnavailable = showSnapshot && (snapshotIsVideo ? !snapshotVideoData?.videoId : !data.hasRejectionSnapshotPdf);

	const renderPlaceholder = snapshotUnavailable || (isHistoricalUnpublished && !snapshotCommentId);
	const renderVideo = !renderPlaceholder && (showSnapshot ? snapshotIsVideo : isVideo);
	const showPdf = !renderPlaceholder && !renderVideo;
	const pdfPath = showSnapshot
		? `/server/review/snapshot/${snapshotCommentId}`
		: (historical && data.isPublished ? `/server/document/view/${data?.publishedDoc}` : `/server-preview`);

	const contentUnavailablePlaceholder = (
		<FlexWrapper direction="column" align="center" justify="center" fullWidth style={{ height: "calc(100vh - 12rem)", color: "#6B7280" }}>
			<Info size={32} color="#9CA3AF" />
			<p className="mt-m">This content is no longer available.</p>
		</FlexWrapper>
	);

	return (
		<>
			{showResolveComment && <ConfirmActionModal {...showResolveComment} text={text} setText={setText} />}
			{confirmActionModal && <ConfirmActionModal {...confirmActionModal} text={text} setText={setText} />}
			<Modal handleClose={handleClose} className="draft-note-preview-modal" overlayClick={handleOverlayClick} modalStyle={{ maxHeight: 'calc(100vh - 10rem)' }}>
				<div className={`preview-wrapper ${commentsOpen ? "right-sidebar-open" : ""}`}>
					{/* Header */}
					<FlexWrapper gap="s" align="center" direction='row' justify={singleDocViewer ? "center" : 'space-between'} className="mt-m pl-xl pr-xl preview-note-modal-header">
						{!singleDocViewer &&
							<FlexWrapper gap="s" align="center" direction='row' justify='center' className="mt-m mb-m " onClick={gotToPreviousNote} style={{ cursor: "pointer", marginLeft: `calc(130px - 2rem` }}>
								<ChevronLeft color="#0D8EFD" />
								<p className="">Previous Note</p>
							</FlexWrapper>
						}
						<FlexWrapper gap="s" align="center" direction='column' justify='center' className="mt-m mb-m">
							<h4>{data?.type ? data.type : data?.templateName ? data.templateName : ""}</h4>
							<h3 style={{ display: 'flex', alignItems: "center" }}>
								{data?.title ? data.title : data?.name ? data.name : data?.ticker ? data.ticker : ""}
								{renderVideo && <VideoIndicator className="ml-s" />}
								{rejectionAction &&
									<Tooltip label={`Rejected by: ${rejectionAction.responderName}, ${format(parseISO(rejectionAction.grantedAt), "hh:mmaaa, dd/MM/yyyy")}`} outerStyle={{ marginLeft: "0.5rem" }} >
										<Info color="#E66780" size={20} />
									</Tooltip>
								}
							</h3>
						</FlexWrapper>
						{!singleDocViewer &&
							<FlexWrapper gap="s" align="center" direction='row' justify='center' className="mt-m mb-m" onClick={gotToNextNote} style={{ cursor: "pointer", marginRight: commentsOpen ? `calc(474px - 1rem` : `calc(130px - 2rem` }}>
								<p>Next Note</p>
								<ChevronRight color="#0D8EFD" />
							</FlexWrapper>
						}
					</FlexWrapper>
					<Divider spacing="bottom-l" />
					<FlexWrapper gap="s" align="flex-start" direction="row">
						{/* Left Sidebar — page navigation is PDF-only; video/placeholder show an equal-width spacer so the content aligns with the PDF column */}
						{!showPdf
							? <div className="floating-sidebar" style={{ minWidth: "100px" }} aria-hidden="true" />
							: <FlexWrapper className="floating-sidebar navigation-menu" direction="column" align="center" gap="s" style={{ minWidth: "100px" }}>
							<p>Page</p>
							<IconLink
								icon={<ChevronsUp color="#0D8EFD" />}
								onClick={() => setPage(calculatePage(page, false, twoPageView, true))}
								active={false}
								label="First Page"
							/>
							<IconLink
								icon={<ChevronUp color="#0D8EFD" />}
								onClick={() => setPage(calculatePage(page, false, twoPageView, false))}
								active={false}
								label="Previous Page"
							/>
							<div className="page-guide">
								<p>{twoPageView ? page === totalPages ? page : `${page} - ${page + 1}` : `${page} / ${totalPages || "1"}`}</p>
							</div>
							<IconLink
								icon={<ChevronDown color="#0D8EFD" />}
								onClick={() => setPage(calculatePage(page, true, twoPageView, false))}
								active={false}
								label="Next Page"
							/>
							<IconLink
								icon={<ChevronsDown color="#0D8EFD" />}
								onClick={() => setPage(calculatePage(page, true, twoPageView, true))}
								active={false}
								label="Last Page"
							/>
							<Divider width="60px" />
							<IconLink
								icon={
									<span className="material-symbols-outlined">
										description
									</span>
								}
								onClick={() => handleSetTwoPageView(false)}
								active={!twoPageView}
								label="Single Page View"
							/>
							<IconLink
								icon={
									<span className="material-symbols-outlined">
										two_pager
									</span>
								}
								onClick={() => handleDoublePage()}
								active={twoPageView}
								label="Double Page View"
							/>
						</FlexWrapper>
						}
						{/* Preview */}
						<FlexWrapper className={`preview-wrapper-inner ${noActions ? "no-actions" : ""}`} direction="column" align="flex-start" gap="m" fullWidth ref={previewContentRef}>
							<ErrorBoundary fallback={errorFallback}>
								{data && renderPlaceholder && contentUnavailablePlaceholder}
								{data && renderVideo && (
									<ReviewVideoPreview
										ticker={data?.ticker}
										template={data?.template ? data.template : data?.templateName ? data?.templateName : data?.type}
										snapshotVideoData={snapshotVideoData}
									/>
								)}
								{data && showPdf && <FlexWrapper direction="row" width="100%" align="flex-start">
									<PDFViewer
										enableKeyboardNavigation
										ticker={data?.ticker}
										template={data?.template ? data.template : data?.templateName ? data?.templateName : data?.type}
										id={data?.docId}
										scale={2}
										customHeight="calc(100vh - 9rem)"
										fullWidth
										setTotalPages={setTotalPages}
										pageOverride={page}
										blankPageMesurements={blankPageMesurements}
										setBlankPageMesurements={setBlankPageMesurements}
										path={pdfPath}
									/>
									{twoPageView &&
										<PDFViewer
											enableKeyboardNavigation
											ticker={data?.ticker}
											template={data?.template ? data.template : data?.templateName ? data?.templateName : data?.type}
											id={data?.docId}
											scale={1}
											fullHeight
											fullWidth
											setTotalPages={setTotalPages}
											pageOverride={page + 1}
											blankPage={page + 1 > totalPages}
											blankPageMesurements={blankPageMesurements}
											setBlankPageMesurements={setBlankPageMesurements}
											path={pdfPath}

										/>
									}
								</FlexWrapper>
									|| null}
							</ErrorBoundary>
						</FlexWrapper>
						{/* Right Sidebar */}
						{!noActions &&
							<FlexWrapper className="floating-sidebar navigation-menu smaller" direction="column" align="center" gap="m" style={{ minWidth: "100px", paddingRight: "0.5rem" }}>
								<IconLink
									icon={<MessageSquare />}
									onClick={() => setCommentsOpen(!commentsOpen)}
									active={commentsOpen}
									variant={comments.length > 0 ? 'active' : ''}
									diabled={!perms.includes("COMMENTS_COMPLIANCE") && !perms.includes("COMMENTS_PEER") && !perms.includes("COMMENTS_SUPERVISOR")}
									counter={unresolvedComments}
									counterClassname="workplace-template-preview-icon-counter"
									className="workplace-template-preview-icon"
								/>
								<Divider spacing="none" width="60px" />
								<IconLink
									icon={<UserCheck />}
									label={perms.includes("REVIEW_PEER") ? "Confirm Peer Review Approval" : perms.includes("REVIEW_COMPLIANCE") ? "Confirm Compliance Approval" : perms.includes("REVIEW_SUPERVISOR") ? "Confirm Supervisor Approval" : null}
									variant={currentUserHasApproved ? "positive" : ""}
									disabled={getIsDisabled('approve')}
									className="workplace-template-preview-icon"
									onClick={() => {
										const disabled = getIsDisabled('approve')
										if (disabled) return null
										else {
											let permittedAction = perms.includes("REVIEW_PEER") ? "approvePeerReview" : perms.includes("REVIEW_COMPLIANCE") ? "approveCompliance" : perms.includes("REVIEW_SUPERVISOR") ? "approveSupervisor" : null
											permittedAction && showConfirmActionModal(permittedAction, setConfirmActionModal, data?.template, data?.ticker, data?.requestId, () => refreshList(true), data?.workflowStatusId)
										}
									}}
								/>
								<IconLink
									icon={<UserX />}
									label={perms.includes("REVIEW_PEER") ? "Deny Peer Review Approval" : perms.includes("REVIEW_COMPLIANCE") ? "Deny Compliance Approval" : perms.includes("REVIEW_SUPERVISOR") ? "Deny Supervisor Approval" : null}
									variant={currentUserHasRejected ? "danger" : ""}
									disabled={getIsDisabled('reject')}
									className="workplace-template-preview-icon"
									onClick={() => {
										const disabled = getIsDisabled('reject')
										if (disabled) return null
										else {
											let permittedAction = perms.includes("REVIEW_PEER") ? "rejectPeerReview" : perms.includes("REVIEW_COMPLIANCE") ? "rejectCompliance" : perms.includes("REVIEW_SUPERVISOR") ? "rejectSupervisor" : null
											// permittedAction && showConfirmActionModal(permittedAction, setConfirmActionModal, data?.template, data?.ticker, data?.requestId, refreshList, text)
											permittedAction && showConfirmActionModal(permittedAction, setConfirmActionModal, data?.template, data?.ticker, data?.requestId, refreshList, data?.workflowStatusId, text)
										}
									}}
								/>
							</FlexWrapper>
						}
						{/* Comments */}
						{/* Historical gate matches the row badge (WorkflowComplianceActionRow): any historical
						    workflow WITH comments shows them — incl. cancelled/rejected ones that were never
						    published (data.isPublished only selects the PDF source above, per RES-1120). */}
						{commentsOpen && (!historical || data.totalComments > 0) && <Divider vertical height={"calc(100vh - 7rem)"} marginTop="-1.5rem" />}
						{commentsOpen && (!historical || data.totalComments > 0) &&
							<FlexWrapper className="floating-sidebar" direction="column" align="flex-start" gap="m" style={{ width: "600px", height: 'calc(100vh - 9rem)', overflowY: 'auto' }}>
								<CommentsSection
									ticker={data && data.ticker}
									templateName={data && data.template}
									compliance={compliance}
									workflowStatusId={data && data.workflowStatusId}
									requestId={data && data.requestId}
									updateParentsComments={setComments}
									setShowResolveComment={setShowResolveComment}
									setText={setText}
									rejectionSubmitted={rejectionSubmitted}
									refreshRequestsList={refreshList}
									uneditable={historical || canNotComment}
									showTitle
								/>
							</FlexWrapper>
						}
					</FlexWrapper>
				</div>
			</Modal>
		</>
	);
};

export default DraftNotePreviewModal;
